module.exports = __webpack_public_path__ + "static/media/SaoPaulo_kmeans_202_450.06c92283.csv";